import { render, staticRenderFns } from "./PrPhotoSwipe.vue?vue&type=template&id=60cd96f0&scoped=true&"
import script from "./PrPhotoSwipe.vue?vue&type=script&lang=js&"
export * from "./PrPhotoSwipe.vue?vue&type=script&lang=js&"
import style0 from "./PrPhotoSwipe.vue?vue&type=style&index=0&id=60cd96f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cd96f0",
  null
  
)

export default component.exports